<!-- Contact Hero Section -->
<section class="contact-hero-section" role="banner" aria-labelledby="contact-hero-title">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <span class="hero-badge">Get In Touch</span>
                    <h1 class="hero-title text-white">Connect with <span class="text-highlight">Cloud Experts</span></h1>
                    <p class="hero-description text-white">Ready to transform your business with cutting-edge cloud infrastructure? Our team of experts is here to help you navigate your cloud journey with NVIDIA GPU technology and enterprise-grade solutions.</p>
                    
                    <div class="contact-highlights">
                        <div class="highlight-item">
                            <div class="highlight-number text-white">24/7</div>
                            <div class="highlight-label text-white">Support Available</div>
                        </div>
                        <div class="highlight-item">
                            <div class="highlight-number text-white">2</div>
                            <div class="highlight-label text-white">Office Locations</div>
                        </div>
                        <div class="highlight-item">
                            <div class="highlight-number text-white">500+</div>
                            <div class="highlight-label text-white">Happy Clients</div>
                        </div>
                    </div>
                    
                    <div class="hero-actions">
                        <a class="btn-primary-gradient" href="#contact-form" aria-label="Send us a message">
                            <i class="bx bx-envelope" aria-hidden="true"></i>
                            Send Message
                        </a>
                        <a class="btn-outline-light" href="tel:+919167663638" aria-label="Call us now">
                            <i class="bx bx-phone" aria-hidden="true"></i>
                            Call Now
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <div class="image-decoration" aria-hidden="true">
                        <div class="floating-card card-1">
                            <i class="bx bx-support" aria-hidden="true"></i>
                            <span>24/7 Support</span>
                        </div>
                        <div class="floating-card card-2">
                            <i class="bx bx-shield-check" aria-hidden="true"></i>
                            <span>Secure Solutions</span>
                        </div>
                        <div class="floating-card card-3">
                            <i class="bx bx-trending-up" aria-hidden="true"></i>
                            <span>Scalable Infrastructure</span>
                        </div>
                    </div>
                    <img src="assets/img/contact-img.png" alt="Contact Us" class="img-fluid main-image" loading="lazy">
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements" aria-hidden="true">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>
<!-- Quick Contact Info Bar -->
<section class="quick-contact-bar" aria-label="Quick contact information">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="quick-contact-wrapper">
                    <div class="quick-contact-item text-white">
                        <i class="bx bx-envelope" aria-hidden="true"></i>
                        <a href="mailto:info@insightfulitservices.com" class="text-white" aria-label="Email us at info@insightfulitservices.com">info@insightfulitservices.com</a>
                    </div>
                    <div class="quick-contact-item text-white">
                        <i class="bx bx-phone" aria-hidden="true"></i>
                        <a href="tel:+919167663638" class="text-white" aria-label="Call us at +91 9167663638">+91 9167663638</a>
                    </div>
                    <div class="quick-contact-item text-white">
                        <i class="bx bx-map" aria-hidden="true"></i>
                        <span>Mumbai, Maharashtra</span>
                    </div>
                    <div class="quick-contact-item text-white">
                        <i class="bx bx-time" aria-hidden="true"></i>
                        <span>Mon-Fri: 9AM-6PM IST</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Contact Methods Section -->
<section class="contact-methods-section ptb-100" aria-labelledby="contact-methods-heading">
    <div class="container">
        <div class="section-title text-center">
            <span class="section-badge">Contact Methods</span>
            <h2 id="contact-methods-heading">Choose Your Preferred <span class="text-highlight">Communication Channel</span></h2>
            <p>Multiple ways to connect with our cloud infrastructure experts for immediate assistance</p>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="contact-method-card primary" tabindex="0">
                    <div class="method-icon">
                        <i class="bx bx-envelope" aria-hidden="true"></i>
                    </div>
                    <div class="method-content">
                        <h3>Email Support</h3>
                        <p>Get detailed responses to technical inquiries</p>
                        <div class="contact-details">
                            <strong>info@insightfulitservices.com</strong>
                            <small>Response within 2-4 hours</small>
                        </div>
                        <a href="mailto:info@insightfulitservices.com" class="method-btn" aria-label="Send email to info@insightfulitservices.com" style="color: white !important;">
                            <i class="bx bx-send" aria-hidden="true"></i>
                            Send Email
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="contact-method-card featured" tabindex="0">
                    <div class="featured-badge">Most Popular</div>
                    <div class="method-icon">
                        <i class="bx bx-phone-call" aria-hidden="true"></i>
                    </div>
                    <div class="method-content">
                        <h3>Phone Support</h3>
                        <p>Speak directly with our technical team</p>
                        <div class="contact-details">
                            <strong>+91 9167663638</strong>
                            <small>Available 24/7</small>
                        </div>
                        <a href="tel:+919167663638" class="method-btn" aria-label="Call +91 9167663638" style="color: white !important;">
                            <i class="bx bx-phone" aria-hidden="true"></i>
                            Call Now
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="contact-method-card" tabindex="0">
                    <div class="method-icon">
                        <i class="bx bxl-whatsapp" aria-hidden="true"></i>
                    </div>
                    <div class="method-content">
                        <h3>WhatsApp Chat</h3>
                        <p>Quick messages for instant support</p>
                        <div class="contact-details">
                            <strong>+91 9167663638</strong>
                            <small>Instant messaging</small>
                        </div>
                        <a href="https://wa.me/919167663638" class="method-btn whatsapp" target="_blank" rel="noopener" aria-label="Chat on WhatsApp" style="color: white !important;">
                            <i class="bx bxl-whatsapp" aria-hidden="true"></i>
                            Chat Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Contact Form & Office Location Section -->
<section class="contact-form-location-section ptb-100" id="contact-form" aria-labelledby="contact-form-heading">
    <div class="container">
        <div class="row">
            <!-- Contact Form Column -->
            <div class="col-lg-7 col-md-12">
                <div class="contact-form-wrapper">
                    <div class="section-title text-center">
                        <span class="section-badge-premium">Get In Touch</span>
                        <h2 id="contact-form-heading" class="gradient-text">Drop us a <span class="text-highlight">Message</span></h2>
                        <p class="section-description">Have a question about our cloud infrastructure services? Fill out the form below and our team will respond within 24 hours during business days.</p>
                    </div>
                    <form id="contactForm" class="modern-contact-form professional-layout premium-form" (ngSubmit)="onSubmit()" #contactForm="ngForm" aria-label="Contact form">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="name">Full Name <span class="required">*</span></label>
                                    <div class="input-wrapper">
                                        <i class="bx bx-user" aria-hidden="true"></i>
                                        <input type="text" name="name" id="name" class="form-control" placeholder="Enter your full name" required [(ngModel)]="contactFormModel.name" (input)="onFieldChange()" aria-required="true">
                                    </div>
                                    <div class="error-message" id="name-error" style="display: none;">
                                        Name is required
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email">Email Address <span class="required">*</span></label>
                                    <div class="input-wrapper">
                                        <i class="bx bx-envelope" aria-hidden="true"></i>
                                        <input type="email" name="email" id="email" class="form-control" placeholder="Enter your email address" required [(ngModel)]="contactFormModel.email" (input)="onFieldChange()" aria-required="true">
                                    </div>
                                    <div class="error-message" id="email-error" style="display: none;">
                                        Email is required
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone">Phone Number <span class="required">*</span></label>
                                    <div class="input-wrapper">
                                        <i class="bx bx-phone" aria-hidden="true"></i>
                                        <input type="tel" name="phone" id="phone" class="form-control" placeholder="Enter your phone number" required [(ngModel)]="contactFormModel.phone" (input)="onFieldChange()" aria-required="true">
                                    </div>
                                    <div class="error-message" id="phone-error" style="display: none;">
                                        Phone number is required
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="subject">Subject <span class="required">*</span></label>
                                    <div class="input-wrapper no-icon">
                                        <select name="subject" id="subject" class="form-control" [class.is-invalid]="isSubjectInvalid()" required [(ngModel)]="contactFormModel.subject" (change)="onFieldChange()" aria-required="true">
                                            <option value="" disabled selected>Select a subject</option>
                                            <option value="General Inquiry">General Inquiry</option>
                                            <option value="Cloud Solutions">Cloud Solutions</option>
                                            <option value="Linux Cloud Hosting">Linux Cloud Hosting</option>
                                            <option value="Windows Cloud Hosting">Windows Cloud Hosting</option>
                                            <option value="GPU Cloud Services">GPU Cloud Services</option>
                                            <option value="Database as a Service (DBaaS)">Database as a Service (DBaaS)</option>
                                            <option value="Storage Solutions">Storage Solutions</option>
                                            <option value="Backup & Recovery">Backup & Recovery</option>
                                            <option value="Load Balancers">Load Balancers</option>
                                            <option value="Network Management">Network Management</option>
                                            <option value="Technical Support">Technical Support</option>
                                            <option value="Billing & Payments">Billing & Payments</option>
                                            <option value="Sales Inquiry">Sales Inquiry</option>
                                            <option value="Partnership Opportunities">Partnership Opportunities</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div class="error-message" id="subject-error" style="display: none;">
                                        Subject is required
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="message">Message <span class="required">*</span></label>
                                    <div class="input-wrapper">
                                        <i class="bx bx-message-detail" aria-hidden="true"></i>
                                        <textarea name="message" id="message" class="form-control" cols="30" rows="6" placeholder="Tell us about your cloud infrastructure requirements..." required [(ngModel)]="contactFormModel.message" (input)="onFieldChange()" aria-required="true"></textarea>
                                    </div>
                                    <div class="error-message" id="message-error" style="display: none;">
                                        Message is required
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-md-12 mb-3">
                                <div class="turnstile-container">
                                    <div id="cf-turnstile-container" class="cf-turnstile" data-sitekey="0x4AAAAAACKDMu5GCxu8ofzB" data-callback="onRecaptchaSuccess"></div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-actions">
                                    <button type="submit" class="btn-submit-primary" [disabled]="isSubmitting || !turnstileVerified">
                                        <i class="bx bx-send" aria-hidden="true"></i>
                                        <span *ngIf="!isSubmitting">Send Message</span>
                                        <span *ngIf="isSubmitting">Sending...</span>
                                    </button>
                                    
                                    <!-- Error Message (only shown when form submission fails) -->
                                    <div *ngIf="submitError" class="alert alert-danger mt-3" role="alert">
                                        <i class="bx bx-error"></i>
                                        {{ errorMessage }}
                                    </div>
                                    
                                    <!-- Success Message -->
                                    <div *ngIf="submitSuccess" class="alert alert-success mt-3" role="alert">
                                        <i class="bx bx-check-circle"></i>
                                        Your message has been sent successfully! We will get back to you soon.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Office Information Sidebar -->
            <div class="col-lg-5 col-md-12">
                <div class="office-info-sidebar">
                    <div class="office-card professional-card">
                        <div class="office-header">
                            <div class="office-icon">
                                <i class="bx bx-buildings" aria-hidden="true"></i>
                            </div>
                            <div class="office-title">
                                <h3>Mumbai Office</h3>
                                <p>Our headquarters and main operations center</p>
                            </div>
                        </div>
                        
                        <div class="office-details">
                            <div class="detail-item">
                                <div class="detail-icon">
                                    <i class="bx bx-map" aria-hidden="true"></i>
                                </div>
                                <div class="detail-content">
                                    <h4>Address</h4>
                                    <p>610, Synergy Premises, Kanchpada<br>Malad (West), Mumbai - 400064<br>Maharashtra, India</p>
                                </div>
                            </div>
                            
                            <div class="detail-item">
                                <div class="detail-icon">
                                    <i class="bx bx-time" aria-hidden="true"></i>
                                </div>
                                <div class="detail-content">
                                    <h4>Business Hours</h4>
                                    <p>Monday - Friday: 9:00 AM - 6:00 PM<br>Saturday: 10:00 AM - 2:00 PM<br>Sunday: Closed</p>
                                </div>
                            </div>
                            
                            <!-- <div class="detail-item">
                                <div class="detail-icon">
                                    <i class="bx bx-train" aria-hidden="true"></i>
                                </div>
                                <div class="detail-content">
                                    <h4>Getting Here</h4>
                                    <p>Malad (West) Station<br>Metro Line 1 (Blue Line)<br>On-site parking available</p>
                                </div>
                            </div> -->
                        </div>
                        
                        <div class="office-actions">
                            <a href="https://maps.google.com/maps?q=Insightful+IT+Services+LLP,+610+Synergy+Premises,+Kanchpada,+Malad+West,+Mumbai+400064,+India" target="_blank" rel="noopener" class="btn-directions" aria-label="Get directions to our Mumbai office">
                                <i class="bx bx-navigation" aria-hidden="true"></i>
                                <span>Get Directions</span>
                            </a>
                            <a href="tel:+919167663638" class="btn-call" aria-label="Call our Mumbai office">
                                <i class="bx bx-phone" aria-hidden="true"></i>
                                <span>Call Now</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Interactive Map Section -->
<section class="interactive-map-section ptb-100" aria-labelledby="map-heading">
    <div class="container-fluid p-0">
        <div class="section-title text-center">
            <span class="section-badge">Our Location</span>
            <h2 id="map-heading">Find Us <span class="text-highlight">On The Map</span></h2>
            <p>Visit our office or get in touch with our team</p>
        </div>
        
        <div class="map-container">
            <div class="map-wrapper">
                <iframe 
                    src="https://maps.google.com/maps?q=Insightful+IT+Services+LLP,+610+Synergy+Premises,+Kanchpada,+Malad+West,+Mumbai+400064,+India&t=&z=16&ie=UTF8&iwloc=&output=embed" 
                    width="100%" 
                    height="500" 
                    style="border:0;" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"
                    class="location-map"
                    title="Google Maps location of Insightful IT Services Mumbai office">
                </iframe>
            </div>
        </div>
    </div>
</section>
<!-- FAQ Section -->
<section class="faq-section ptb-100">
    <div class="container">
        <div class="section-title text-center">
            <span class="section-badge">FAQ</span>
            <h2>Frequently Asked <span class="text-highlight">Questions</span></h2>
            <p>Find answers to common questions about our cloud services and support</p>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-9">
                <div class="faq-accordion">
                    <div class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button" type="button" (click)="toggleAccordion($event)">
                                <span class="accordion-question-text">What are your support hours?</span>
                                <span class="accordion-icon-wrapper">
                                    <i class="bx bx-chevron-down accordion-icon"></i>
                                </span>
                            </button>
                        </h3>
                        <div class="accordion-content">
                            <p>Our technical support team is available 24/7 for all enterprise clients. For non-enterprise clients, support is available Monday through Friday from 9:00 AM to 6:00 PM IST. We also offer emergency support for critical infrastructure issues at any time.</p>
                        </div>
                    </div>
                    
                    <div class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button" type="button" (click)="toggleAccordion($event)">
                                <span class="accordion-question-text">How quickly can I expect a response?</span>
                                <span class="accordion-icon-wrapper">
                                    <i class="bx bx-chevron-down accordion-icon"></i>
                                </span>
                            </button>
                        </h3>
                        <div class="accordion-content">
                            <p>We guarantee a response within 2 hours for critical issues and within 24 hours for all other inquiries during business days. Our average response time is 15 minutes for enterprise clients. Emergency support is available 24/7 with immediate callback for critical infrastructure problems.</p>
                        </div>
                    </div>
                    
                    <div class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button" type="button" (click)="toggleAccordion($event)">
                                <span class="accordion-question-text">Do you offer on-site support?</span>
                                <span class="accordion-icon-wrapper">
                                    <i class="bx bx-chevron-down accordion-icon"></i>
                                </span>
                            </button>
                        </h3>
                        <div class="accordion-content">
                            <p>Yes, we provide on-site support for enterprise clients with critical infrastructure requirements in Mumbai and Noida regions. Our technical experts can visit your location for setup, maintenance, and troubleshooting. Please contact our sales team to discuss your specific needs and service level agreements.</p>
                        </div>
                    </div>
                    
                    <div class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button" type="button" (click)="toggleAccordion($event)">
                                <span class="accordion-question-text">How do I access your knowledge base?</span>
                                <span class="accordion-icon-wrapper">
                                    <i class="bx bx-chevron-down accordion-icon"></i>
                                </span>
                            </button>
                        </h3>
                        <div class="accordion-content">
                            <p>Our comprehensive knowledge base is available at knowledge.insightfulitservices.com. Enterprise clients receive direct access credentials with priority support documentation. Other clients can access public articles, guides, and video tutorials covering common setup procedures and troubleshooting steps.</p>
                        </div>
                    </div>
                    
                    <div class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button" type="button" (click)="toggleAccordion($event)">
                                <span class="accordion-question-text">What cloud services do you provide?</span>
                                <span class="accordion-icon-wrapper">
                                    <i class="bx bx-chevron-down accordion-icon"></i>
                                </span>
                            </button>
                        </h3>
                        <div class="accordion-content">
                            <p>We offer a complete range of cloud infrastructure services including Linux Cloud Hosting, Windows Cloud Hosting, GPU Cloud Computing with NVIDIA technology, Database as a Service (DBaaS), Storage Solutions (Block, Object, and Archive), Load Balancers, and Managed IT Services. All services come with 99.9% uptime SLA and 24/7 monitoring.</p>
                        </div>
                    </div>
                </div>
                
                <div class="faq-helper">
                    <p>Still have questions? Our team is here to help!</p>
                    <a href="tel:+919167663638" aria-label="Call us for more information">
                        <i class="bx bx-phone"></i>
                        Call Us Now
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>